// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3d6ed902] .p-card .p-card-body{padding:.5rem}[data-v-3d6ed902] .p-card{background:#fff;color:#212529;box-shadow:none;border-radius:0}", ""]);
// Exports
module.exports = exports;
